import {Box, Drawer, Grid, IconButton, Typography} from '@mui/material';
import {t} from 'i18next';
import {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import {
  getSuggestedQuestionList,
  sendAskLioQurey,
} from '../../api/AskLioService';
import {ReactComponent as CloseIcon} from '../../assests/svg/lio-close.svg';
import {ReactComponent as LioOrbIcon} from '../../assests/svg/lio-orb.svg';
import {
  addAskLioQuery,
  setChatId,
  setFeedbackPromptVisibility,
  setFeedbackVisibility,
  setHasNotification,
  setIsChatPanelVisible,
  setResponseOnProcess,
  setShouldCloseAutomatically,
  updateAskLioQuery,
  updateSuggesteduestions,
} from '../../redux/slices/askLioSlice';
import {RootState} from '../../redux/store';
import {isEmpty} from '../../utils/utils';
import {ReactComponent as ThumbsUpIcon} from './../../../src/assests/svg/thumbs-up.svg';
import AurAskLioChatBody from './AurAskLioChatBody';
import AurAskLioFeedback from './AurAskLioFeedback';
import AurAskLioFeedbackToast from './AurAskLioFeedbackToast';
import AurQuerySubmissionBox from './AurQuerySubmissionBox';
import styles from './style.module.scss';
import {UrlPathEnums} from '../../utils/enumUtils';

const TOAST_TIMEOUT = 3000;
const INITIAL_CHATID = '00000000-0000-0000-0000-000000000000';

type AurAskLioProps = {
  isLioOpen: boolean;
  testId?: string;
  onClose: () => void;
};

const AurAskLio = ({
  isLioOpen: isLeoOpen,
  testId = '',
  onClose,
}: AurAskLioProps) => {
  const dispatch = useDispatch();
  const [feedbackToastVisible, setFeedbackToastVisible] = useState(false);
  const [showSuggestedQuestions, setShowSuggestedQuestions] = useState(false);
  const [
    showSuggestedQuestionsOnResponseReceived,
    setshowSuggestedQuestionsOnResponseReceived,
  ] = useState(false);
  const chatId = useSelector((state: RootState) => state.askLioSlice.chatId);
  const askLioInlineQuery = useSelector(
    (state: RootState) => state.askLioSlice.askLioQuery
  );
  const isFeedbackVisible = useSelector(
    (state: RootState) => state.askLioSlice.isFeedbackVisible
  );
  const responseOnProcess = useSelector(
    (state: RootState) => state.askLioSlice.responseOnProcess
  );
  const entity = useSelector((state: RootState) => state.askLioSlice.entity);
  const task = useSelector((state: RootState) => state.askLioSlice.task);
  const suggestedQuestions = useSelector(
    (state: RootState) => state.askLioSlice.suggestedQuetions
  );
  const [query, setQuery] = useState<string>('');

  const isLioOpen = useSelector(
    (state: RootState) => state.askLioSlice.isChatPanelVisible
  );
  const shouldCloseAutomatically = useSelector(
    (state: RootState) => state.askLioSlice.shouldCloseAutomatically
  );
  const location = useLocation();
  const prevPath = useRef<string>();

  useEffect(() => {
    if (isLioOpen && prevPath.current != UrlPathEnums.NlpSearch) {
      prevPath.current = location.pathname;
    } else if (shouldCloseAutomatically) {
      prevPath.current = '';
      dispatch(setIsChatPanelVisible(false));
    } else if (
      !isEmpty(prevPath.current) &&
      prevPath.current == UrlPathEnums.NlpSearch &&
      !isLioOpen
    ) {
      prevPath.current = '';
    }
  }, [dispatch, isLioOpen, location.pathname]);

  useEffect(() => {
    fetchAskLioSuggestedQuestion(entity, task);
  }, [entity, task]);

  useEffect(() => {
    if (isLeoOpen && suggestedQuestions && suggestedQuestions.length > 0) {
      if (responseOnProcess) {
        setshowSuggestedQuestionsOnResponseReceived(true);
      } else {
        setShowSuggestedQuestions(true);
      }
    }
  }, [isLeoOpen]);

  useEffect(() => {
    if (!responseOnProcess && showSuggestedQuestionsOnResponseReceived) {
      setShowSuggestedQuestions(true);
    }
  }, [responseOnProcess]);

  useEffect(() => {
    if (!responseOnProcess && showSuggestedQuestionsOnResponseReceived) {
      setShowSuggestedQuestions(true);
    }
  }, [showSuggestedQuestionsOnResponseReceived]);

  const fetchAskLioSuggestedQuestion = async (entity: string, task: string) => {
    if (entity && task) {
      try {
        const result = await getSuggestedQuestionList(entity, task);

        dispatch(updateSuggesteduestions(result.data?.data ?? []));
        if (isLeoOpen) {
          if (responseOnProcess) {
            setshowSuggestedQuestionsOnResponseReceived(true);
          } else {
            setShowSuggestedQuestions(true);
          }
        }
      } catch (error) {
        setShowSuggestedQuestions(false);
        dispatch(updateSuggesteduestions([]));
      }
    }
  };

  const onHandleSendbtn = async (query: string) => {
    const queryDate: string = new Date().toUTCString();

    dispatch(setFeedbackPromptVisibility(false));
    setShowSuggestedQuestions(false);
    setshowSuggestedQuestionsOnResponseReceived(false);
    setFeedbackToastVisible(false);
    dispatch(addAskLioQuery({query}));
    dispatch(setResponseOnProcess(true));
    setQuery('');
    const lastQueryIndex = askLioInlineQuery.length - 1;
    try {
      const response = await sendAskLioQurey({
        question: query,
        chatId,
      });

      if (!chatId || chatId === INITIAL_CHATID) {
        dispatch(setChatId(response.data.data.chatId));
      }

      const obj = {
        ...askLioInlineQuery[lastQueryIndex],
        additionalButtonInfo: response.data.data.questions ?? '',
        content: response.data.data.answer ?? '',
        query,
        responseDate: new Date().toUTCString(),
      };

      dispatch(updateAskLioQuery(obj));
      dispatch(setResponseOnProcess(false));
      dispatch(setHasNotification(true));

      if (location.pathname == UrlPathEnums.NlpSearch)
        dispatch(setShouldCloseAutomatically(false));
    } catch (error) {
      console.error('error', error);
      const obj = {
        ...askLioInlineQuery[lastQueryIndex],
        additionalButtonInfo: [] as string[],
        content: '',
        query,
        isLoading: false,
        queryDate: queryDate,
        responseDate: new Date().toUTCString(),
      };
      dispatch(updateAskLioQuery(obj));
      dispatch(setResponseOnProcess(false));
    }
  };

  return (
    <Box data-testid={testId}>
      <Drawer
        className={`${styles.aurLioChatPanel}`}
        variant="persistent"
        anchor="right"
        sx={{
          '& .MuiDrawer-paper': {
            zIndex: 1300,
          },
        }}
        open={isLeoOpen}
      >
        <Box className={`${styles.aurResponsiveContainer}`} component="aside" aria-labelledby={t('askLio.askLioTitle')}>
          <Box className={`${styles.aurAskLioHeaderContainer}`}>
            <Grid container>
              <Grid item xs={8}>
                <Box className={`${styles.aurAskLioOrbContainer}`}>
                  <Box className={`${styles.aurAskLioOrbIcon}`}>
                    <LioOrbIcon aria-hidden="true" />
                  </Box>
                  <Box>
                    <Typography className={`${styles.aurAskLioHeaderText}`} tabIndex={0} id={t('askLio.askLioTitle')} component="h2">
                      {t('askLio.askLioHeader')}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box className={`${styles.aurAskLioCloseButton}`}>
                  <IconButton
                    aria-label={t('askLio.close')}
                    onClick={() => onClose()}
                  >
                    <CloseIcon aria-hidden="true" />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box className={`${styles.aurResponsiveChatBody}`}>
            <AurAskLioChatBody
              chat={askLioInlineQuery}
              onHandleSend={onHandleSendbtn}
              triggerScroll={isFeedbackVisible}
              showSuggestedQuestionBlock={showSuggestedQuestions}
              suggestedQuestions={suggestedQuestions}
              feedbackToastVisible={
                feedbackToastVisible || feedbackToastVisible
              }
            />
          </Box>
          <Box className={`${styles.aurResponsiveQueryBox}`}>
            <AurAskLioFeedbackToast
              title={`${t('askLio.feedback.rateFeedbackToastTitle')}`}
              Icon={ThumbsUpIcon}
              visible={feedbackToastVisible}
              className={styles.bottom12}
            />
            {isFeedbackVisible ? (
              <AurAskLioFeedback
                onClick={() => {
                  setFeedbackToastVisible(true);
                  dispatch(setFeedbackVisibility(false));
                  dispatch(setFeedbackPromptVisibility(false));
                  setTimeout(() => {
                    setFeedbackToastVisible(false);
                  }, TOAST_TIMEOUT);
                }}
              />
            ) : (
              <AurQuerySubmissionBox
                query={query}
                setQuery={setQuery}
                onHandleSend={onHandleSendbtn}
                disabled={responseOnProcess}
              />
            )}
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
};

export default AurAskLio;
